import { gql } from "@apollo/client";

export default gql`
  query getReviewChatSessionId($assessmentId: Int!) {
    reviewChatSessionId(assessmentId: $assessmentId)
  }
`;
